<template>
<img :class="$style['pt-img']" :src="isIncludeHttp?src:styleName?(imgUrl+src+ '?x-image-process=style/'+styleName):imgUrl+src"/>
</template>
<script>
export default {
  name: 'pt-img',
  props: {
    isPublic: {
      type: Boolean,
      default: true
    },
    src: {
      type: String,
      default: ''
    },
    styleName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      imgUrl: this.isPublic ? this.$publicResourcesUrl : this.$privateResourcesUrl
    }
  },
  computed: {
    // 图片连接中是否包含http
    isIncludeHttp () {
      return (this.src && (this.src.indexOf('http://') > -1 || this.src.indexOf('https://') > -1)) || false
    }
  }
}
</script>
<style module lang="less">
.pt-img{
    border-radius: 10px
}
</style>
